import { FC, useState } from 'react';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useIntl } from 'react-intl';

import { useDrawerContext } from '../../../../../drawer/DrawerContext';
import { DeleteOutline, Edit, Filter1, WarningRounded } from '@mui/icons-material';
import { useModalContext } from '../../../../../modal/ModalContext';
import { useLocation } from 'react-router';

type Props = Readonly<{
	touchpointId: string;
	activityId: string;
	value: string | null | undefined;
	hasWarnings?: boolean;
	phaseId: string;
}>;

const NameCell: FC<Props> = ({ value, touchpointId, activityId, hasWarnings, phaseId }) => {
	const intl = useIntl();
	const theme = useTheme();
	const { pathname } = useLocation();

	const [, setEditMode] = useState(false);
	const [showEdit, setShowEdit] = useState(false);
	const { setDrawerWithoutPrevParams } = useDrawerContext();
	const { setModal } = useModalContext();

	const hideDuplicationForSubactivity = pathname.includes('subactivity');

	return (
		<Stack
			onMouseEnter={() => setShowEdit(true)}
			onMouseLeave={() => setShowEdit(false)}
			direction={'row'}
			columnGap={1}
			alignItems={'center'}
			sx={{ paddingRight: '50px' }}
			position={'relative'}
		>
			<Typography justifyContent={'center'} variant={'h5'} fontSize={18}>
				{value}
			</Typography>
			{hasWarnings && <WarningRounded htmlColor={theme.palette.error.main} />}
			{showEdit && (
				<Stack flexDirection={'row'} alignItems={'center'} gap={1} sx={{ position: 'absolute', top: 0, right: 0 }}>
					<Tooltip title={intl.formatMessage({ id: 'journey.detail.widget.edit' })}>
						<IconButton
							sx={{ width: '20px', height: '20px' }}
							color={'default'}
							size={'medium'}
							onClick={() => {
								setDrawerWithoutPrevParams('editName', { activityId }, () => setEditMode(false));
								setEditMode(true);
							}}
						>
							<Edit sx={{ width: 16, height: 16 }} />
						</IconButton>
					</Tooltip>
					{!hideDuplicationForSubactivity && (
						<Tooltip title={intl.formatMessage({ id: 'activity.duplicate' })}>
							<IconButton
								sx={{ width: '20px', height: '20px' }}
								color={'default'}
								onClick={() => setModal({ type: 'duplicateActivity', payload: { id: activityId } })}
							>
								<Filter1 sx={{ width: '20px', height: '20px' }} />
							</IconButton>
						</Tooltip>
					)}
					<Tooltip title={intl.formatMessage({ id: 'activity.delete' })}>
						<IconButton
							sx={{ width: '20px', height: '20px' }}
							color={'default'}
							onClick={() => setModal({ type: 'deleteActivity', payload: { id: touchpointId, name: value ?? '' } })}
						>
							<DeleteOutline sx={{ width: '20px', height: '20px' }} />
						</IconButton>
					</Tooltip>
				</Stack>
			)}
		</Stack>
	);
};

export { NameCell };
